import Icon from '@tiger/icons';
import { useSWR } from '@tiger/swr';
import React, { FC, Fragment, useMemo, useState } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
import { $Formutil, withForm } from 'react-bootstrap-formutil';
import Button from 'components/base/Button';
import Dialog from 'components/base/Dialog';
import { ModalHandler } from 'components/base/Modal';
import FormGroup from 'components/FormGroup';
import API, { APICollection, getAPIEnv, isQA, removeAPIEnv, saveAPIEnv } from 'utils/API';

export interface APIManagerProps extends ModalHandler {
    $formutil: $Formutil;
}

// TODO: 暂时区分qa环境，未来移出单独的qa环境
const hostIndex = isQA ? 2 : 0;

const APIManager: FC<APIManagerProps> = ({ close }) => {
    const [currentEnv] = useState(() => getAPIEnv());
    const {
        data: envOptions,
        isLoading,
        error,
        mutate
    } = useSWR<string[]>(
        {
            url: API.CG.environments(),
            params: {
                appName: 'TradeUP'
            }
        },
        {
            immutable: true,
            dataChain: (resp: { environments: string[] }) => resp.environments
        }
    );

    const apiFormItems = useMemo(() => {
        return Object.keys(APICollection).map(name => {
            const { HOST, HOST_ALIAS, OAUTH_ROUTE_HOSTS } = APICollection[name];
            // oauth相关的接口文件中, 不是以HOST_ALIAS的形式存在的, 而是以OAUTH_ROUTE_HOSTS的形式存在的
            const curAlias = HOST_ALIAS || OAUTH_ROUTE_HOSTS;

            return (
                <Fragment key={name}>
                    <FormGroup name={name} label={name} $defaultValue={HOST[hostIndex] || HOST[0]}>
                        <FormControl readOnly />
                    </FormGroup>
                    {curAlias && (
                        <div className="ml-3">
                            {Object.keys(curAlias).map(alias => {
                                return (
                                    <FormGroup
                                        key={`${name}:${alias}`}
                                        name={`${name}:${alias}`}
                                        label={`${name}:${alias}`}
                                        $defaultValue={curAlias[alias][hostIndex] || curAlias[alias][0]}>
                                        <FormControl size="sm" readOnly />
                                    </FormGroup>
                                );
                            })}
                        </div>
                    )}
                </Fragment>
            );
        });
    }, []);

    const reset = () => {
        removeAPIEnv();

        window.location.reload();
    };

    const handleSwitchEnvironment = env => {
        saveAPIEnv(env);

        Dialog.confirm({
            content: `将切换到${env}环境域名，该配置在页面刷新后生效，立即刷新？`
        })
            .then(() => {
                close();

                window.location.reload();
            })
            .catch(() => {});
    };

    return (
        <div className="api-manager-root">
            <div className="manager-head">
                <div className="d-flex align-items-center justify-content-between py-1">
                    <Button onClick={() => close()} type="link" size="lg" className="text-body">
                        <Icon type="left" />
                        关闭
                    </Button>
                    <div className="d-flex align-items-center pr-2">
                        {isLoading || error ? (
                            <Button loading={isLoading} onClick={error ? () => mutate() : undefined}>
                                获取环境列表
                            </Button>
                        ) : (
                            <Dropdown>
                                <Dropdown.Toggle id="env-list">快捷切换环境</Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {envOptions?.map(envName => (
                                        <Dropdown.Item
                                            active={envName === currentEnv}
                                            key={envName}
                                            onClick={() => handleSwitchEnvironment(envName)}>
                                            {envName}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                </div>
                <hr className="mt-0" />
            </div>
            <form noValidate className="px-3 pt-2">
                <h4 className="mb-3">当前环境：{currentEnv || '默认环境'}</h4>
                {apiFormItems}
                <div className="manager-foot py-3">
                    <hr />
                    <Button
                        size="sm"
                        className="mt-2 text-body"
                        htmlType="button"
                        type="link"
                        block
                        onClick={() => {
                            Dialog.confirm({
                                content: '页面将会刷新，并重置接口环境为默认配置？'
                            })
                                .then(() => reset())
                                .catch(() => {});
                        }}>
                        恢复默认
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default withForm(APIManager);
